import { Gender } from '@modules/types/graphql';

export const genderTranslates = {
    [Gender.nogender]: 'common:blocks.gender.nogender',
    [Gender.male]: 'common:blocks.gender.male',
    [Gender.female]: 'common:blocks.gender.female',
};
